(function () {
  function initScrollHeader() {
    var header = document.querySelector('header-component');
    if (!header) return;
    var OFFSET = 50;
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > OFFSET);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollHeader);
  } else {
    initScrollHeader();
  }
})();
